import type { ComponentType } from "react";
import { createRegistry } from "./registry";

/** A component a feature keeps mounted inside the shell, such as the preferences sync. */
export interface ShellMount {
  id: string;
  component: ComponentType;
}

const mounts = createRegistry<ShellMount>("shell mounts");

/** Mounts a component in the shell for the whole signed-in session; throws on a duplicate id. */
export const registerShellMount = (mount: ShellMount): void => mounts.register(mount);

export const shellMounts = (): ShellMount[] => mounts.list();
